module.exports = __webpack_public_path__ + "static/media/twitter-logo-blue.a7a925c7.svg";